import { defineType } from 'sanity';

export const seoOptimizedImageUrl = defineType({
    name: 'seoOptimizedImageUrl',
    title: 'SEO Optimized Image URL',
    type: 'object',
    fields: [
        {
            name: 'url',
            title: 'URL',
            type: 'url',
        },
        {
            name: 'alt',
            title: 'Alt',
            type: 'localizedString',
        },
    ],
});
